
import React, { useState } from 'react';
import { useForm } from 'react-hook-form';
import { Button } from '@/components/ui/button';
import { Input } from '@/components/ui/input';

interface FormData {
  email: string;
  password: string;
}

interface AdminFormProps {
  onSubmit: (data: FormData) => Promise<void>;
  loading: boolean;
  error: string | null;
}

const AdminForm: React.FC<AdminFormProps> = ({ onSubmit, loading, error }) => {
  const form = useForm<FormData>({
    defaultValues: {
      email: ''
    }
  });

  return (
    <form onSubmit={form.handleSubmit(onSubmit)}>
      <div className="space-y-4 mt-4">
        <div className="bg-amber-50 border border-amber-200 p-3 rounded-md mb-4">
          <p className="text-sm text-amber-800">
            This area is restricted to system administrators only.
          </p>
        </div>
        
        <div className="space-y-2">
          <label htmlFor="admin-email" className="block text-sm font-medium">
            Admin Email
          </label>
          <Input
            id="admin-email"
            type="email"
            placeholder="Enter admin email"
            {...form.register('email', { required: true })}
          />
        </div>

        <div className="space-y-2">
          <label htmlFor="admin-password" className="block text-sm font-medium">
            Admin Password
          </label>
          <Input
            id="admin-password"
            type="password"
            placeholder="••••••••"
            {...form.register('password', { required: true })}
          />
        </div>

        {error && <p className="text-sm text-red-500">{error}</p>}
        
        <Button type="submit" className="w-full mt-2 bg-green-600 hover:bg-green-700 text-white" disabled={loading}>
          {loading ? 'Authenticating...' : 'Admin Login'}
        </Button>
      </div>
    </form>
  );
};

export default AdminForm;
